var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name !== 'NotFound')?_c('Header'):_vm._e(),(_vm.$store.getters.isLoading)?_c('PreLoader'):_vm._e(),_c('router-view'),(_vm.$route.name !== 'NotFound')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }